import RandingStyle4 from "../../randing/RandingStyle4";

function Randing038({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/038/24122601.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/038/24122602.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/038/24122603.jpg`} // 스텝 변경되는 이미지
      benefitInfoPosition="top"
      formFieldColor="white"
      qBoxBackgroundColor="#f4f4f4"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/ApplyBenefitButton.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
    />
  );
}

export default Randing038;
